import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class HelperService {

  fileModifid = false;

  panPettern = /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/;
  panPetternWithP = /^[A-Za-z]{3}[Pp][A-Za-z]{1}[0-9]{4}[A-Za-z]{1}$/;
  panPetternWithF = /^[A-Za-z]{3}[Ff][A-Za-z]{1}[0-9]{4}[A-Za-z]{1}$/;

  constructor() { }

  onlyNumbersChars(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }
    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return false;
    }

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (this.checkNumber(keynum) || this.checkAlphabet(keynum)) {
      return true;
    }

    return false;
  }

  onlyChars(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return false;
    }

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (!this.checkAlphabet(keynum)) {
      return false;
    }
    return true;

  }

  onlyPercent(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.keyCode == 46 || e.which == 46) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return false;
    }

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (!this.checkNumber(keynum)) {
      return false;
    }
    return true;

  }

  onlyAsstYear(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.keyCode == 45 || e.which == 45) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return false;
    }

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (!this.checkNumber(keynum)) {
      return false;
    }
    return true;

  }


  onlyNumbers(e) {
    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return false;
    }

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (!this.checkNumber(keynum)) {
      return false;
    }
    return true;

  }


  onlyNegativeNumbers(e) {
   console.log("negative_working");
    this.fileModified();

    if (e.target.value != '' && e.target.value.length > 1 && e.target.value.charAt(0) != '-' && e.target.originalLength) {
      e.target.maxLength = e.target.originalLength;
    }

    var keynum;

    // minus(-) sign should not be more than one
    if (e.target.value.charAt(0) === '-' && e.target.value.charAt(1) === '-') {
      return false;
    }

    if (e.target.value.charAt(0) != '-') {
      e.target.maxLength = parseInt('14', 10);

    } else {
      e.target.maxLength = parseInt('15', 10);

    }

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return false;
    }

    if (e.keyCode == 45 || e.which == 45) {
      if (e.target.originalLength) {
        e.target.maxLength = parseInt(e.target.originalLength, 10) + parseInt('1', 10);
      } else {
        e.target.originalLength = e.target.maxLength;
        e.target.maxLength = parseInt(e.target.originalLength, 10) + parseInt('1', 10);
      }
      return true;
    }


    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (!this.checkNumber(keynum)) {
      return false;
    }
    return true;

  }

  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    if (pastedText.length > 6) {
      event.preventDefault()
    }
    console.log('clipboard data', pastedText, pastedText.length);

  }

  maxLength(e, length) {
    this.fileModified();
    console.log(e.target.value.length);

    if (e.target.value.charAt(0) != '-' && e.target.value.length == length) {

      return false;
    }
    else if (e.target.value.charAt(0) == '-' && e.target.value.length == length + 1) { return false; }
  }

  onlyDate(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }


    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return false;
    }


    if (e.keyCode == 47 || e.which == 47) {
      return true;
    }

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (!this.checkNumber(keynum)) {
      return false;
    }
    return true;
  }

  // '.&  Only Allowed

  /*
  . -- 46
  ' -- 39
  & -- 38
  , -- 44
  # -- 35
  - -- 45
  / -- 47
  */


  disableBackSpace(e) {
    if (e.keyCode == 8 || e.which == 8) {
      return false;
    }
    else {
      return true;
    }

  }




  onlyName(e) {

    this.onlyMidName(e);

    /*	var keynum;

      if (e.keyCode == 13 ||e.which == 13 ) {
        return true;
      }

      if (e.which == 0 ) {
        return true;
      }


      if (e.keyCode == 46 ||e.which == 46 ) {
        return true;
      }

      if (e.keyCode == 9 ||e.which == 9 ) {
        return true;
      }

      if (e.keyCode == 38 ||e.which == 38 ) {
        return true;
      }


      if (e.keyCode == 183 ||e.which == 183 ) {
        return true;
      }

      if (e.keyCode == 39 ||e.which == 39 ) {
        return true;
      }


      if (e.keyCode == 8 ||e.which == 8 ) {
        return true;
      }

      if (e.keyCode == 32 ||e.which == 32) {
        return true;
      }

      if (window.event) // IE
      {
        keynum = e.keyCode;
      } else if (e.which) // Netscape/Firefox/Opera
      {
        keynum = e.which;
      }

      if (this.checkNumber(keynum) || checkAlphabet(keynum)) {
        return true;
      }

      return false; */

  }

  // Only Allowed Special Chars ' , . & # - /
  /*
    . -- 46
    ' -- 39
    & -- 38
    , -- 44
    # -- 35
    - -- 45
    / -- 47
    ( -- 40
    ) -- 41
  */

  onlyAddress(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 183 || e.which == 183) {
      return true;
    }

    if (e.keyCode == 39 || e.which == 39) {
      return true;
    }

    if (e.keyCode == 44 || e.which == 44) {
      return true;
    }

    if (e.keyCode == 46 || e.which == 46) {
      return true;
    }

    if (e.keyCode == 38 || e.which == 38) {
      return true;
    }

    if (e.keyCode == 35 || e.which == 35) {
      return true;
    }

    if (e.keyCode == 36 || e.which == 36) {
      return true;
    }

    if (e.keyCode == 64 || e.which == 64) {
      return true;
    }

    if (e.keyCode == 45 || e.which == 45) {
      return true;
    }

    if (e.keyCode == 47 || e.which == 47) {
      return true;
    }


    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return true;
    }

    if (e.keyCode == 40 || e.which == 40) {
      return true;
    }

    if (e.keyCode == 41 || e.which == 41) {
      return true;
    }

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (this.checkNumber(keynum) || this.checkAlphabet(keynum)) {
      return true;
    }

    return false;

  }


  checkNumber(keynum) {

    this.fileModified();

    if (!(keynum >= 48 && keynum <= 57)) {
      return false;
    }
    else {
      return true;
    }

  }


  checkAlphabet(keynum) {

    this.fileModified();

    if (!(keynum >= 65 && keynum <= 90) && !(keynum >= 97 && keynum <= 122)) {
      return false;
    }
    else {
      return true;
    }

  }

  onlyEmailId(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }
    if (e.keyCode == 46 || e.which == 46) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }
    if (e.keyCode == 11 || e.which == 11) {
      return true;
    }


    if (e.keyCode == 95 || e.which == 95) {
      return true;
    }

    if (e.keyCode == 64 || e.which == 64) {
      return true;
    }

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (this.checkNumber(keynum) || this.checkAlphabet(keynum)) {
      return true;
    }

    return false;
  }

  onlyMidName(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }


    if (e.keyCode == 46 || e.which == 46) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 38 || e.which == 38) {
      return true;
    }


    if (e.keyCode == 183 || e.which == 183) {
      return true;
    }

    if (e.keyCode == 39 || e.which == 39) {
      return true;
    }


    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return true;
    }

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (this.checkNumber(keynum) || this.checkAlphabet(keynum)) {
      return true;
    }

    return false;

  }

  onlyVerificationFullName(name) {

    this.fileModified();

    var test_result = false;

    if (name.value !== null) {
      test_result = /^\w(?:\w+|([.\x20])(?!\1))+\s*$/.test(name.value);
    }

    if (name.value !== null && test_result == true) {
      var check = /^[0-9\040]*$/.test(name.value);
      if (check == true) {
        test_result = false;
      }
    }

    if (test_result == false) {
      alert('Please enter Name in correct format');

    }
  }

  onlyTanName(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 46 || e.which == 46) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 38 || e.which == 38) {
      return true;
    }


    if (e.keyCode == 183 || e.which == 183) {
      return true;
    }

    if (e.keyCode == 39 || e.which == 39) {
      return true;
    }


    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return true;
    }

    if (e.keyCode == 45 || e.which == 45) {
      return true;
    }

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (this.checkNumber(keynum) || this.checkAlphabet(keynum)) {
      return true;
    }

    return false;

  }

  onlyOrgName(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }


    if (e.keyCode == 46 || e.which == 46) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 38 || e.which == 38) {
      return true;
    }


    if (e.keyCode == 183 || e.which == 183) {
      return true;
    }

    if (e.keyCode == 39 || e.which == 39) {
      return true;
    }


    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return true;
    }

    if (e.keyCode == 45 || e.which == 45) {
      return true;
    }


    if (e.keyCode == 35 || e.which == 35) {
      return true;
    }
    if (e.keyCode == 95 || e.which == 95) {
      return true;
    }
    if (e.keyCode == 40 || e.which == 40) {
      return true;
    }
    if (e.keyCode == 41 || e.which == 41) {
      return true;
    }
    if (e.keyCode == 123 || e.which == 123) {
      return true;
    }
    if (e.keyCode == 125 || e.which == 125) {
      return true;
    }
    if (e.keyCode == 91 || e.which == 91) {
      return true;
    }
    if (e.keyCode == 93 || e.which == 93) {
      return true;
    }
    if (e.keyCode == 43 || e.which == 43) {
      return true;
    }
    if (e.keyCode == 64 || e.which == 64) {
      return true;
    }
    if (e.keyCode == 44 || e.which == 44) {
      return true;
    }
    if (e.keyCode == 47 || e.which == 47) {
      return true;
    }
    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (this.checkNumber(keynum) || this.checkAlphabet(keynum)) {
      return true;
    }

    return false;

  }

  onlyDesignation(e) {

    this.fileModified();
    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 46 || e.which == 46) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 38 || e.which == 38) {
      return true;
    }


    if (e.keyCode == 183 || e.which == 183) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return true;
    }

    if (e.keyCode == 45 || e.which == 45) {
      return true;
    }
    if (e.keyCode == 40 || e.which == 40) {
      return true;
    }
    if (e.keyCode == 41 || e.which == 41) {
      return true;
    }
    if (e.keyCode == 44 || e.which == 44) {
      return true;
    }
    if (e.keyCode == 47 || e.which == 47) {
      return true;
    }
    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (this.checkNumber(keynum) || this.checkAlphabet(keynum)) {
      return true;
    }

    return false;

  }

  restrictMaxLength(e) {
    this.fileModified();

    var field = (<HTMLInputElement>document.getElementById("issue")).value;
    var keynum;


    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;

    }

    if (field.length >= 250) {

      if (e.keyCode == 9 || e.which == 9) {
        return true;
      }
      else if (e.which == 0) {
        return true;
      }

      else if (e.keyCode == 8 || e.which == 8) {
        return true;
      }
      else {
        return false;
      }

    }
  }

  disableEnter(e) {

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    return false;
  }

  restrictMaxLengthTextField(e, field, len) {
    this.fileModified();

    if (this.textFieldRequiredKeys(e)) {

      return true;
    }
    if (field.value.length >= len) {

      return false;

    } else {
      return true;
    }

  }

  textFieldRequiredKeys(e) {

    this.fileModified();

    var keynum;

    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;

    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }
    if (e.keyCode == 46 || e.which == 46) {
      return true;
    }



    if (e.keyCode == 40 || e.which == 40) {
      return true;
    }

    if (e.keyCode == 38 || e.which == 38) {
      return true;
    }
    if (e.keyCode == 39 || e.which == 39) {
      return true;
    }
    if (e.keyCode == 37 || e.which == 37) {
      return true;
    }
    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }
    return false;

  }

  onlyBankAccNo(e) {
    this.fileModified();
    var keynum;
    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }
    if (e.which == 0) {
      return true;
    }
    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }
    if (e.keyCode == 47 || e.which == 47) {
      return true;
    }
    if (e.keyCode == 45 || e.which == 45) {
      return true;
    }
    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }
    /*if (e.keyCode == 32 ||e.which == 32) {
    return true;
    }*/
    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }
    if (this.checkNumber(keynum) || this.checkAlphabet(keynum)) {
      return true;
    }
    return false;
  }

  onlyLLPIN(e) {

    this.fileModified();

    var keynum;

    if (e.keyCode == 13 || e.which == 13) {
      return true;
    }

    if (e.keyCode == 9 || e.which == 9) {
      return true;
    }
    if (e.which == 0) {
      return true;
    }

    if (e.keyCode == 8 || e.which == 8) {
      return true;
    }

    if (e.keyCode == 32 || e.which == 32) {
      return false;
    }
    if (e.keyCode == 45 || e.which == 45) {
      return true;
    }
    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }

    if (this.checkNumber(keynum) || this.checkAlphabet(keynum)) {
      return true;
    }

    return false;
  }

  fileModified() {
    this.fileModifid = true;
  }

  setFileModifiedFalse() {
    this.fileModifid = false;
  }

  onlyAlphaNumericWithoutSpace(e) {
    this.fileModified();

    let keynum;

    if (e.keyCode === 32 || e.which === 32) {
      return false;
    }
    if (window.event) // IE
    {
      keynum = e.keyCode;
    } else if (e.which) // Netscape/Firefox/Opera
    {
      keynum = e.which;
    }
    if (this.checkNumber(keynum) || this.checkAlphabet(keynum)) {
      return true;
    }

    return false;

  }

  dateConvertUsingMoment(date) {
    if (date) {
      let dateTime = moment.utc(date, "YYYY-MM-DD HH").local().format('YYYY-MM-DD');
      return dateTime;
    }
    return;
  }

  findMinimum(value1, value2) {
    let value = (value1 > value2) ? value2 : value1;
    return value;
  }

  getZeroIfNull(value) {
    let result = (value == null) ? 0 : value;
    return result;
  }


  isValidPan(pan: String) {
    if (pan == null) return false;
    return pan.match(this.panPettern);
  }

  isValidPanWithP(pan: String) {
    if (pan == null) return false;
    return pan.match(this.panPetternWithP);
  }
  isValidPanWithF(pan: String) {
    if (pan == null) return false;
    return pan.match(this.panPetternWithF);
  }

  isEmptyStr(str: String) {
    return !(str && str.trim().length > 0);
  }

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
}

  onlyNumberAndDecimalPlace(event) {
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    return (this.onlyNumbers(event) || key === '.');
  }

  isEmpty(obj) {
    if (obj === undefined || obj == null || obj === '') {
      return true;
    }

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  };

  hasPropertisValue(obj) {
    if (obj === undefined || obj == null || obj === '') {
      return false;
    }

    for (const key in obj) {
      if (obj[key] != null && obj[key] !== undefined && obj[key] !== '') {
        return true;
      }
    }
    return false;
  };

  onlyCharAndNumber(e){
    if((e.charCode >= 65 && e.charCode <= 90) || (e.charCode >= 97 && e.charCode <= 122) || (e.charCode >= 48 && e.charCode <= 57)){
      return true;
    }
    else{
      return false;
    }

  }
}
